import { Html, useProgress } from "@react-three/drei";

// Lade-Komponente für den Fortschritt
export default function Loader() {
	const { active, progress } = useProgress();
	return (
		<>
			{active ||
				(true && (
					<Html center>
						<div className="canvas-loading">
							<strong>Laden...</strong>
							<span>{Math.round(progress)}%</span>
						</div>
					</Html>
				))}
		</>
	);
}
